export default {
    name: 'year',
    serverName: '​/api/v1/rb_calculator/fertilizer_action_year/',
    apiUrl: '/api/v1/rb_calculator/fertilizer_action_year/'
};
